module.exports = __webpack_public_path__ + "static/media/06.8ab3fa83.png";